export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS'

export const fetchCurrentUserSuccess = (userData) => ({
  type: FETCH_CURRENT_USER_SUCCESS,
  payload: userData
})
